import { render } from "./PrivacyISS.vue?vue&type=template&id=a1f1e498"
const script = {}

import "./PrivacyISS.vue?vue&type=style&index=0&id=a1f1e498&lang=css"

import exportComponent from "/var/www/digiasia.asia.bak/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__